import { sendTrackingLog } from '../data/api'
import { loadNextAd } from '../player/player'

// VAST Error Codes (simplified, no dependency on eventAnalytics.js)
export const AUTOPLAY_WAS_PREVENTED = 408
export const FILE_NOT_FOUND = 401
export const GENERAL_LINEAR_ERROR = 400
export const MEDIAFILE_COULD_NOT_BE_FOUND = 404
export const MEDIAFILE_NOT_SUPPORTED = 406
export const PROBLEM_DISPLAYING_MEDIAFILE = 405
export const TIMEOUT_OF_MEDIAFILE_URI = 407
export const TIMEOUT_OF_VAST_URI = 301
export const UNDEFINED_ERROR = 900
export const VAST_SCHEMA_VALIDATION_ERROR = 101
export const VAST_VERSION_NOT_SUPPORTED = 102
export const XML_PARSING_ERROR = 100

// Simple error description function
export const getErrorDescription = (errorCode) => {
  const errorMap = {
    100: 'XML parsing error',
    101: 'VAST schema validation error',
    102: 'VAST version not supported',
    301: 'Timeout of VAST URI',
    400: 'General linear error',
    401: 'File not found',
    404: 'MediaFile could not be found',
    405: 'Problem displaying MediaFile',
    406: 'MediaFile not supported',
    407: 'Timeout of MediaFile URI',
    408: 'Autoplay was prevented',
    900: 'Undefined error'
  }
  return errorMap[errorCode] || 'Unknown error'
}

/**
 * Setup media error tracking for HTML5 video element
 * @param {HTMLMediaElement} mediaElement - The video element
 * @param {string} adexchangeId - Ad exchange ID
 * @param {string} src - Media source URL
 */
export const setupMediaErrorTracking = async (mediaElement, adexchangeId, src) => {
  const error = mediaElement.error
  let errorCode = GENERAL_LINEAR_ERROR
  let description = 'Unknown media error'

  if (error) {
    switch (error.code) {
      case MediaError.MEDIA_ERR_ABORTED:
        errorCode = FILE_NOT_FOUND
        description = 'Media playback was aborted'
        break
      case MediaError.MEDIA_ERR_NETWORK:
        errorCode = TIMEOUT_OF_MEDIAFILE_URI
        description = 'Network error while loading media'
        break
      case MediaError.MEDIA_ERR_DECODE:
        errorCode = PROBLEM_DISPLAYING_MEDIAFILE
        description = 'Media decoding error'
        break
      case MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
        errorCode = MEDIAFILE_NOT_SUPPORTED
        description = 'Media format not supported'
        break
      default:
        errorCode = GENERAL_LINEAR_ERROR
        description = `Media error code: ${error.code}`
    }
  }

  await sendTrackingLog({
    adexchangeId,
    eventType: 'error',
    errorCode,
    description: getErrorDescription(errorCode),
    vastTag: src
  })

  // Track autoplay prevention
  const playPromise = mediaElement.play()
  if (playPromise && typeof playPromise.catch === 'function') {
    playPromise.catch(async (error) => {
      if (error.name === 'NotAllowedError') {
        await sendTrackingLog({
          adexchangeId,
          eventType: 'error',
          errorCode: AUTOPLAY_WAS_PREVENTED,
          description: getErrorDescription(AUTOPLAY_WAS_PREVENTED),
          vastTag: src
        })
      }
    })
  }
}
